import { render } from "./_Main.vue?vue&type=template&id=391a1d87"
const script = {}
script.render = render

export default script